import { AuthWrapper } from './AuthWrapper'
import { motion, AnimatePresence } from 'framer-motion';
import clsx from 'clsx';
import { RegisterForm } from './Register';
import { useState, useEffect } from 'react';
import SignIn from './SignIn';
import { useLocation } from 'react-router-dom';

const IndexAuth = () => {
    const location = useLocation();
    const [showLogin, setShowLogin] = useState(true);

    // Initialize tab state from URL
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tab = searchParams.get('tab');
        setShowLogin(tab !== 'register');
    }, [location.search]);

    return (
        <AuthWrapper pageTitle="Sign In">
            <div className={clsx('')}>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={showLogin ? 'login' : 'register'}
                        initial={{ opacity: 0, x: showLogin ? -20 : 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: showLogin ? 20 : -20 }}
                        transition={{ duration: 0.3 }}
                        className="">
                        {showLogin ? <SignIn /> : <RegisterForm />}
                    </motion.div>
                </AnimatePresence>
            </div>
        </AuthWrapper>
    )
}

export default IndexAuth